export default __webpack_public_path__ + "static/media/spinning.d6d275ce.jpg";